<template>
  <div style="width: fit-content">
    <div style="width: fit-content">
      <button @click="mountChild()" class="btn btn-outline-secondary btn-sm" type="button" style="width: fit-content">
        {{ $t("message.find_partner.download_pdf") }}
      </button>
    </div>
    <div v-if="isChildMounted" id="invisible-child" style="display: none;">
      <div id="pdf-content">
        <slot :childFullyLoaded="childFullyLoaded" :height="height" :width="width"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import { jsPDF } from 'jspdf'
// for supporting cyrillic
import { PTSansBold, PTSansRegular } from "./PT-Sans_base64.js";
export default {
  props: {
    pageMarginsInPx: {
      type: Number | Array,
      default: 30,
    },
    pageFullWidthInPx: {
      type: Number,
      default: 1400,
    },
    filename: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      isChildMounted: false,
      isChildLoaded: false,
      doc: null,

      jsPdfSettings: {
        scale: null,
        scaledMargins: null,
        xMarginsSum: null,
        yMarginsSum: null,
      }
    }
  },
  mounted() {
    this.loadDoc();
  },
  computed: {
    height() {
      return Math.trunc((this.doc.internal.pageSize.getHeight() / this.jsPdfSettings.scale) - this.jsPdfSettings.yMarginsSum)// + 1 test second page
    },
    width() {
      return Math.trunc(this.doc.internal.pageSize.getWidth() / this.jsPdfSettings.scale - this.jsPdfSettings.xMarginsSum)
    },
  },
  methods: {
    mountChild() {
      this.isChildMounted = true;
    },
    childFullyLoaded() {
      // Must be called when child is fully loaded
      this.makeJsPdf();
    },
    loadDoc() {
      this.doc = new jsPDF({ unit: "px" });
      this.doc.addFileToVFS("PTSans-Bold.ttf", PTSansBold)
      this.doc.addFileToVFS("PTSans-Regular.ttf", PTSansRegular)
      this.doc.addFont("PTSans-Bold.ttf", "PT Sans", "normal", "bold")
      this.doc.addFont("PTSans-Regular.ttf", "PT Sans", "normal", "normal")
      this.doc.setFont("PT Sans", "normal", "bold");
      this.doc.setFont("PT Sans", "normal", "normal");

      const width = this.doc.internal.pageSize.getWidth();
      const scale = width / this.pageFullWidthInPx;

      let xMarginsSum = null;
      let yMarginsSum = null;
      let scaledMargins = null;
      if (Array.isArray(this.pageMarginsInPx)) {
        xMarginsSum = this.pageMarginsInPx[1] + this.pageMarginsInPx[3];
        yMarginsSum = this.pageMarginsInPx[0] + this.pageMarginsInPx[2];
        scaledMargins = this.pageMarginsInPx.map((margin) => margin * scale);
      }
      else {
        xMarginsSum = this.pageMarginsInPx * 2;
        yMarginsSum = this.pageMarginsInPx * 2;
        scaledMargins = this.pageMarginsInPx * scale;
      }
      this.jsPdfSettings.scaledMargins = scaledMargins;
      this.jsPdfSettings.xMarginsSum = xMarginsSum;
      this.jsPdfSettings.yMarginsSum = yMarginsSum;
      this.jsPdfSettings.scale = scale;

    },
    makeJsPdf() {
      let parentEl = document.getElementById("invisible-child")

      parentEl.firstChild.style.width = (this.pageFullWidthInPx - this.jsPdfSettings.xMarginsSum) + "px";
      parentEl.firstChild.style.maxWidth = (this.pageFullWidthInPx - this.jsPdfSettings.xMarginsSum) + "px";
      parentEl.firstChild.style.margin = "0px"
      this.doc.html(
        parentEl.innerHTML,
        {
          callback: (doc) => {
            doc.save(this.filename);
            this.isChildMounted = false;
          },
          margin: this.jsPdfSettings.scaledMargins,
          html2canvas: {
            scale: this.jsPdfSettings.scale
          },
          autoPaging: "text",
        }
      )
    },
  },
};
</script>
<style>
#pdf-content h1,
#pdf-content h2,
#pdf-content h3,
#pdf-content h4,
#pdf-content h5,
#pdf-content h6,
#pdf-content p,
#pdf-content div,
#pdf-content span,
#pdf-content ul,
#pdf-content ol,
#pdf-content li,
#pdf-content table,
#pdf-content tr,
#pdf-content td,
#pdf-content th,
#pdf-content thead,
#pdf-content tbody,
#pdf-content tfoot,
#pdf-content b,
#pdf-content strong,
#pdf-content i,
#pdf-content em,
#pdf-content u,
#pdf-content s,
#pdf-content strike,
#pdf-content a {
  font-family: "PT Sans" !important;
  font-weight: normal;
}
</style>